/* MM · Gåvospärr: gratis gåvor (rader med _gave eller 0 kr) max 1 st per gåva,
   och bara så länge ett betalt paket med tillräckligt antal ligger i korgen. */
(function () {
  if (window.MMGaveSperre) return;
  window.MMGaveSperre = true;
  var KEY = 'mm-gaver';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, again = false, last = null, timer;
  var fr = document.querySelector('[data-mm-frist]');
  var frEnd = fr ? parseInt(fr.dataset.end, 10) * 1000 : 0;
  var frTxt = fr ? fr.dataset.tekst || '' : '';

  function rules() {
    var map = {};
    try { map = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
    document.querySelectorAll('[data-mm-config]').forEach(function (el) {
      try {
        (JSON.parse(el.textContent).gifts || []).forEach(function (g) {
          if (g.variantId) map[g.variantId] = g.min || 1;
        });
      } catch (e) {}
    });
    try { sessionStorage.setItem(KEY, JSON.stringify(map)); } catch (e) {}
    return map;
  }
  function fristOver() { return !!frEnd && Date.now() >= frEnd; }
  function p2(n) { return n < 10 ? '0' + n : n; }
  function left() {
    var s = Math.max(0, Math.floor((frEnd - Date.now()) / 1000));
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    return (d > 0 ? d + 'd ' : '') + p2(h) + 't ' + p2(m) + 'm ' + p2(x) + 's';
  }
  /* Rad med nedräkning i varukorgen så länge gåvor ligger där och tiden inte gått ut. */
  function banner(cart) {
    var show = !!frEnd && !fristOver() && !!cart && !!cart.items && cart.items.some(isGift);
    document.querySelectorAll('#CartDrawer .drawer__footer, #main-cart-footer .cart__blocks').forEach(function (box) {
      var el = box.querySelector('.mm-frist');
      if (!show) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'mm-frist';
        var parts = frTxt.split('{tid}');
        el.appendChild(document.createTextNode(parts[0] || ''));
        var b = document.createElement('b');
        b.setAttribute('data-mm-frist-tid', '');
        el.appendChild(b);
        if (parts[1]) el.appendChild(document.createTextNode(parts[1]));
        box.insertBefore(el, box.firstChild);
      }
      el.querySelector('[data-mm-frist-tid]').textContent = left();
    });
  }
  function isGift(it) { return !!(it.properties && it.properties._gave) || it.original_price === 0; }
  function units(it) {
    var n = 1;
    (it.options_with_values || []).forEach(function (o) {
      var m = /^(\d+)\s*(stk|pk|pakke|pack|x)\b/i.exec(String(o.value).trim());
      if (m) n = parseInt(m[1], 10);
    });
    return n * it.quantity;
  }
  function mark(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (it, i) {
      ['CartDrawer-Item-' + (i + 1), 'CartItem-' + (i + 1)].forEach(function (id) {
        var row = document.getElementById(id);
        if (!row) return;
        if (isGift(it)) row.setAttribute('data-mm-gave', '');
        else row.removeAttribute('data-mm-gave');
      });
    });
  }
  function html(str, sel) {
    var el = new DOMParser().parseFromString(str, 'text/html').querySelector(sel);
    return el ? el.innerHTML : null;
  }
  function render(json) {
    var s = json.sections || {};
    var drawer = document.querySelector('cart-drawer');
    var inner = s['cart-drawer'] && html(s['cart-drawer'], '#CartDrawer');
    var dst = document.getElementById('CartDrawer');
    if (drawer && inner !== null && inner !== undefined && dst) {
      dst.innerHTML = inner;
      drawer.classList.toggle('is-empty', !json.item_count);
      var ov = document.getElementById('CartDrawer-Overlay');
      if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
    }
    var bubble = s['cart-icon-bubble'] && html(s['cart-icon-bubble'], '.shopify-section');
    var bd = document.getElementById('cart-icon-bubble');
    if (bubble !== null && bubble !== undefined && bd) bd.innerHTML = bubble;
    if (document.querySelector('cart-items') && /\/cart\/?$/.test(location.pathname)) location.reload();
  }
  async function check() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var map = rules(), paid = 0, seen = {}, updates = {}, n = 0;
      cart.items.forEach(function (it) { if (!isGift(it)) paid += units(it); });
      cart.items.forEach(function (it) {
        if (!isGift(it)) return;
        var want = !fristOver() && paid >= (map[it.variant_id] || 1) && !seen[it.variant_id] ? 1 : 0;
        seen[it.variant_id] = true;
        if (it.quantity !== want) { updates[it.key] = want; n++; }
      });
      if (!n) { last = cart; mark(cart); banner(cart); return; }
      var res = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }),
      });
      last = await res.json();
      render(last);
      mark(last);
      banner(last);
    } catch (e) {
    } finally {
      busy = false;
      if (again) { again = false; soon(150); }
    }
  }
  function soon(ms) { clearTimeout(timer); timer = setTimeout(check, ms || 250); }
  function watch() {
    var mo = new MutationObserver(function (muts) {
      var own = muts.every(function (m) {
        var t = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        if (t && t.closest && t.closest('.mm-frist')) return true;
        var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        return nodes.length > 0 && nodes.every(function (x) { return x.classList && x.classList.contains('mm-frist'); });
      });
      if (!own) soon(250);
    });
    document.querySelectorAll('cart-drawer, cart-items').forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true });
    });
  }
  rules();
  watch();
  soon(50);
  if (frEnd) {
    var iv = setInterval(function () {
      if (fristOver()) { clearInterval(iv); soon(50); return; }
      document.querySelectorAll('[data-mm-frist-tid]').forEach(function (b) { b.textContent = left(); });
    }, 1000);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) soon(50); });
})();
